var lazyloadImages, lazyloadThrottleTimeout;

function lazyload() {
  if (lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }

  lazyloadThrottleTimeout = setTimeout(function () {
    if (lazyloadImages.length == 0) {
      document.removeEventListener('scroll', lazyload);
      window.removeEventListener('resize', lazyload);
      window.removeEventListener('orientationChange', lazyload);
    }
  }, 20);
}

document.addEventListener('DOMContentLoaded', function () {

  if ('IntersectionObserver' in window) {

    lazyloadImages = document.querySelectorAll('.lazy-bg');

    var imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var image = entry.target,
            bgImg = image.getAttribute('data-image');

          image.style.backgroundImage = 'url("' + bgImg + '")';
          image.classList.remove('lazy-bg');
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function (image) {
      imageObserver.observe(image);
    });
  } else {
    lazyloadImages = document.querySelectorAll('.lazy-bg');

    document.addEventListener('scroll', lazyload);
    window.addEventListener('resize', lazyload);
    window.addEventListener('orientationChange', lazyload);
  }
});


// WEBPACK FOOTER //
// ./scripts/util/lazy-load.js